import BaseValidator from 'ember-cp-validations/validators/base';

/**
## Test Function Validator

This is a basic validator that takes an option named test that should take one
argument and return true if the value is valid, false otherwise.
*/
export default BaseValidator.extend({
  validate(value, {
    message,
    test
  }) {
    if (test(value)) {
      return true;
    }
    return {
      isValid: false,
      message
    };
  }
});